<template>
  <!-- 直播详情 -->
  <div class="my-live">
    <div class="head" @click="handleClickJump">
      <img :src="proxyResult && proxyResult.icon" alt="">
      <div class="head-box">
        <div class="live-tips">
          <!-- <img src="" alt=""> -->
          <span>{{ dataResult && dataResult.liveState }}</span>
        </div>
        <div class="title">{{ proxyResult && proxyResult.title }}</div>
        <div class="time">会议时间:{{ dataResult && dataResult.startTxt }} ~ {{ dataResult && dataResult.endTxt }}</div>
      </div>
    </div>
    <img src="../../assets/images/article/live-banner.png" alt="" class="icon-banner">
    <div class="live-box">
      <div v-html="_pxToRem(proxyResult.content)"></div>
    </div>
    <returnBack></returnBack>
    <!--自定义分享 icon-->
    <img class="live-share" src="@/assets/images/common/ic_share.png" alt="分享" @click="openSharePoster" />
    <!--特定直播详情页显示icon-->
    <img
      v-if="showDetailIcon"
      class="detail-jump-icon"
      :src="dataResult.detailIconUrl"
      alt="自定义按钮"
      @click.stop="handleDetailJump"
    />
    <footerCom :defaultProxyDetails="defaultProxyDetails" @handleLike="handleLike" @handleCollect="handleCollect" @handleClickLive="handleClickLive"></footerCom>
    <!--自定义分享弹窗-->
    <LiveSharePoster
      v-if="sharePosterVisible"
      :background="shareCodeIcon"
      :live-id="liveId"
      :share-user-id="userInfo.id"
      :live-title="proxyResult.title"
      @close="sharePosterVisible = false"
    />
  </div>
</template>
<script>
import returnBack from '@/views/person/components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { liveGetInfoById, getUserAESCode, getUserAESCodeV2 } from '@/api/api'
import footerCom from '@/views/article/components/footerCom'
import LiveSharePoster from '@/views/home/components/LiveSharePoster.vue'
import { articleUnLike, articleLike, articleUserCollect, articleUnUserCollect } from '@/api/article'
import Style from '@/utils/Style.js'
import { handleTraceFunction } from '@/utils/trace'
const UserProfile = {
  name: 'LiveDetails',
  mixins: [Style],
  components: {
    returnBack,
    footerCom,
    LiveSharePoster
  },
  data() {
    return {
      dataResult: {},
      proxyResult: {},
      defaultProxyDetails: {},
      liveLink: '',
      shareCodeIcon: '',
      sharePosterVisible: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    liveId() {
      return this.$route.query.liveId
    },
    // 特定直播详情页显示icon
    showDetailIcon() {
      const visible = this.dataResult && this.dataResult.detailIconVisible
      const shown = visible === 1 || visible === '1' || visible === true
      return shown && !!(this.dataResult && this.dataResult.detailIconUrl)
    }
  },
  mounted () {
    this.handleFun()
  },
  methods: {
    handleClickLive() {
      window.location.href = this.liveLink
      // this.$toast(this.defaultProxyDetails.liveState)
    },
    handleFun() {
      liveGetInfoById({liveId: this.$route.query.liveId}).then(res => {
        if (res.code === 0) {
          this.dataResult = res.data
          window.sessionStorage.setItem('mainId', this.dataResult.id)
          this.proxyResult = res.data.baseProxy
          this.shareCodeIcon = res.data.shareCodeIcon || res.data.baseProxy.icon || ''
          this.defaultProxyDetails = Object.assign(this.dataResult, this.proxyResult)
          this.dataResult.startTxt = this.$moment(parseInt(this.dataResult.start)).format('YYYY-MM-DD HH:mm')
          this.dataResult.endTxt = this.$moment(parseInt(this.dataResult.end)).format('YYYY-MM-DD HH:mm')
          const getCodeApi = `${this.dataResult.platform}` === '5' ? getUserAESCodeV2 : getUserAESCode
          getCodeApi({userId: this.userInfo.id}).then(codeRes => {
            window.sessionStorage.setItem('serviceId', this.$route.query.liveId)
            this.liveLink = `${this.proxyResult.video}&code=${codeRes.data}`
          }).catch(err => {
            console.error(err)
          })
        }
      })
    },
    // 打开自定义分享弹窗
    openSharePoster() {
      if (!this.shareCodeIcon) {
        this.$toast('暂未配置分享图片')
        return
      }
      this.sharePosterVisible = true
    },
    handleClickJump() {
      if (`${this.dataResult.isOpenLive}` === '1') {
        window.location.href = this.liveLink
      } else {
        this.$toast('暂未开始！')
      }
    },
    // 特定直播详情页显示icon-跳转
    handleDetailJump() {
      const url = `${this.dataResult.detailJumpUrl || ''}`.trim()
      if (!url) return
      if (/^https?:\/\//i.test(url)) {
        handleTraceFunction({
          functionName: '直播详情自定义按钮',
          functionUrl: url,
          createTime: new Date().getTime(),
          serviceId: this.liveId
        })
        window.location.href = url
      }
    },
    // 点赞
    handleLike() {
      if (this.proxyResult.isLike) {
        const params = {
          userId: this.userInfo.id,
          baseId: this.dataResult.id,
          type: 7,
          kind: 7
        }
        articleUnLike(params).then(res => {
          if (res.code === 0) {
            this.$toast('取消点赞成功')
            this.handleFun()
          }
        })
      } else {
        const params = {
          type: 7,
          likeId: this.dataResult.id,
          likeTitle: this.proxyResult.title,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId,
          cover: this.proxyResult.icon,
          kind: 7,
        }
        articleLike(params).then(res => {
          if (res.code === 0) {
            this.$toast('点赞成功')
            this.handleFun()
          }
        })
      }
    },
    // 收藏
    handleCollect() {
      if (this.proxyResult.isCollect) {
        const params = {
          baseId: this.dataResult.id,
          baseType: 7,
          userId: this.userInfo.id,
          userName: this.userInfo.realName
        }
        articleUnUserCollect(params).then(res => {
          if (res.code === 0) {
            this.$toast('取消收藏成功')
            this.handleFun()
          }
        })
      } else {
        const params = {
          userId: this.userInfo.id,
          baseId: this.dataResult.id,
          baseType: 7,
        }
        articleUserCollect(params).then(res => {
          if (res.code === 0) {
            this.$toast('收藏成功')
            this.handleFun()
          }
        })
      }
    },
  }
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-live {
  background: url('../../assets/images/article/articleDetails-bg.png') no-repeat center center / 100% 100%;
  min-height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  .head{
    width: 100%;
    height: 202px;
    border-radius: 0px 0px 0px 0px;
    position: relative;
    img{
      width: 100%;
      height: 202px;
      position: relative;
    }
    &::after{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient( 180deg, rgba(0,0,0,0.3) 49%, #000000 100%);
    }
    .head-box{
      position: absolute;
      bottom: 6px;
      left: 12px;
      z-index: 2;
      .live-tips{
        width: 70px;
        height: 20px;
        background: linear-gradient( 118deg, #FF4141 0%, #FF3385 100%);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 14px;
          height: 14px;
        }
        span{
          font-weight: 600;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 14px;
          text-align: center;
        }
      }
      .title{
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 20px;
        margin-top: 4px;
      }
      .time{
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 20px;
      }
    }
  }
  .icon-banner{
    padding-top: 18px;
    width: 100%;
    height: 24px;
    margin-bottom: 8px;
  }
  .live-box{
    flex: 1;
    border-radius: 12px;
    margin:0 12px 76px;
    position: relative;
    overflow-y: scroll;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
  }
  .live-share {
    position: fixed;
    z-index: 1000;
    right: 20px;
    bottom: 148px;
    width: 40px;
    display: block;
  }
  .detail-jump-icon {
    position: fixed;
    z-index: 1000;
    right: 10px;
    width: 60px;
    display: block;
    top: 202px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/liveDetails.vue